class GameAudio extends Audio {
        public constructor(init?: any) {
                super();
                this.preload = 'auto';
                this.controls = true;
                this.muted = true;
                this.setAttribute('controlsList', 'nodownload');
                this.src = init;
                console.log(this);
        }
}

export class AudioHelper {
        static Start_Game_Countdown = new GameAudio('/audios/(2)_Start_Game_Countdown.mp3');
        static Card_and_Answer_Selection = new GameAudio('/audios/(3)_Card_and_Answer_Selection.mp3');
        static Card_Flip_2nd_sound = new GameAudio('/audios/(4)_Card_Flip_2nd_sound.mp3');
        static Card_Transfer_Deck_to_Across_Screen_slow_down = new GameAudio('/audios/(5)_Card_Transfer_Deck_to_Across_Screen_slow_down.mp3');
        static Energy_Quiz_Correct_Answer_1st_sound = new GameAudio('/audios/(6)_Energy_Quiz_Correct_Answer_1st_sound.mp3');
        static Energy_Quiz_Incorrect_Answer_1st_sound = new GameAudio('/audios/(7)_Energy_Quiz_Incorrect_Answer_1st_sound.mp3');
        static Saver_Correct_Quiz_Renewable_Energy_card_Points = new GameAudio('/audios/(8)_Saver_Correct_Quiz_Renewable_Energy_card_Points.mp3');
        static Waster_Dirty_Energy_Points_2nd_sound = new GameAudio('/audios/(9)_Waster_Dirty_Energy_Points_2nd_sound.mp3');
        static Renewable_Energy_card_chee_hoo = new GameAudio('/audios/(10)_Renewable_Energy_card_chee_hoo.mp3');
        static Fossil_Fuel_card_points_floating_card_in_middle_of_screen_until_points_are_processed = new GameAudio('/audios/(11)_Fossil_Fuel_card_points_floating_card_in_middle_of_screen_until_points_are_processed.mp3');
        static Peak_Load = new GameAudio('/audios/(12)_Peak_Load.mp3');
        static Game_Won_Crowd_Cheering_0_6_sec = new GameAudio('/audios/(13)_Game_Won_Crowd_Cheering_0_6_sec.mp3');
        static Game_Lost_Sad_Trombone = new GameAudio('/audios/(14)_Game_Lost_Sad_Trombone.mp3');
        static shuffling_cards_2 = new GameAudio('/audios/(15b)_shuffling_cards_2.mp3');
        static WHOOSH = new GameAudio('/audios/(16)_WHOOSH.mp3');

        public static playSound = (sound: string) => {
                switch (sound) {
                        case 'Start_Game_Countdown':
                                AudioHelper.Start_Game_Countdown.muted = false;
                                AudioHelper.Start_Game_Countdown.play();
                                console.log(AudioHelper.Start_Game_Countdown);
                                break;

                        case 'Card_and_Answer_Selection':
                                AudioHelper.Card_and_Answer_Selection.muted = false;
                                AudioHelper.Card_and_Answer_Selection.play();
                                break;

                        case 'Card_Flip_2nd_sound':
                                AudioHelper.Card_Flip_2nd_sound.muted = false;
                                AudioHelper.Card_Flip_2nd_sound.play();
                                break;

                        case 'Card_Transfer_Deck_to_Across_Screen_slow_down':
                                AudioHelper.Card_Transfer_Deck_to_Across_Screen_slow_down.muted = false;
                                AudioHelper.Card_Transfer_Deck_to_Across_Screen_slow_down.play();
                                break;
                        
                        case 'Energy_Quiz_Correct_Answer_1st_sound':
                                AudioHelper.Energy_Quiz_Correct_Answer_1st_sound.muted = false;
                                AudioHelper.Energy_Quiz_Correct_Answer_1st_sound.play();
                                break;
                        
                        case 'Energy_Quiz_Incorrect_Answer_1st_sound':
                                AudioHelper.Energy_Quiz_Incorrect_Answer_1st_sound.muted = false;
                                AudioHelper.Energy_Quiz_Incorrect_Answer_1st_sound.play();
                                break;
                        
                        case 'Saver_Correct_Quiz_Renewable_Energy_card_Points':
                                AudioHelper.Saver_Correct_Quiz_Renewable_Energy_card_Points.muted = false;
                                AudioHelper.Saver_Correct_Quiz_Renewable_Energy_card_Points.play();
                                break;

                        case 'Waster_Dirty_Energy_Points_2nd_sound':
                                AudioHelper.Waster_Dirty_Energy_Points_2nd_sound.muted = false;
                                AudioHelper.Waster_Dirty_Energy_Points_2nd_sound.play();
                                break;
                        
                        case 'Renewable_Energy_card_chee_hoo':
                                AudioHelper.Renewable_Energy_card_chee_hoo.muted = false;
                                AudioHelper.Renewable_Energy_card_chee_hoo.play();
                                break;
                        
                        case 'Fossil_Fuel_card_points_floating_card_in_middle_of_screen_until_points_are_processed':
                                AudioHelper.Fossil_Fuel_card_points_floating_card_in_middle_of_screen_until_points_are_processed.muted = false;
                                AudioHelper.Fossil_Fuel_card_points_floating_card_in_middle_of_screen_until_points_are_processed.play();
                                break;
                        
                        case 'Peak_Load':
                                AudioHelper.Peak_Load.muted = false;
                                AudioHelper.Peak_Load.play();
                                break;
                        
                        case 'Game_Won_Crowd_Cheering_0_6_sec':
                                AudioHelper.Game_Won_Crowd_Cheering_0_6_sec.muted = false;
                                AudioHelper.Game_Won_Crowd_Cheering_0_6_sec.play();
                                break;
                        
                        case 'Game_Lost_Sad_Trombone':
                                AudioHelper.Game_Lost_Sad_Trombone.muted = false;
                                AudioHelper.Game_Lost_Sad_Trombone.play();
                                break;

                        case 'shuffling_cards_2':
                                AudioHelper.shuffling_cards_2.muted = false;
                                AudioHelper.shuffling_cards_2.play();
                                break;
                        
                        case 'WHOOSH':
                                AudioHelper.WHOOSH.muted = false;
                                AudioHelper.WHOOSH.play();
                                break;
                }
        }

        public static playAll = () => {
                AudioHelper.Start_Game_Countdown.play();
                AudioHelper.Card_and_Answer_Selection.play();
                AudioHelper.Card_Flip_2nd_sound.play();
                AudioHelper.Card_Transfer_Deck_to_Across_Screen_slow_down.play();
                AudioHelper.Energy_Quiz_Correct_Answer_1st_sound.play();
                AudioHelper.Energy_Quiz_Incorrect_Answer_1st_sound.play();
                AudioHelper.Saver_Correct_Quiz_Renewable_Energy_card_Points.play();
                AudioHelper.Waster_Dirty_Energy_Points_2nd_sound.play();
                AudioHelper.Renewable_Energy_card_chee_hoo.play();
                AudioHelper.Fossil_Fuel_card_points_floating_card_in_middle_of_screen_until_points_are_processed.play();
                AudioHelper.Peak_Load.play();
                AudioHelper.Game_Won_Crowd_Cheering_0_6_sec.play();
                AudioHelper.Game_Lost_Sad_Trombone.play();
                AudioHelper.shuffling_cards_2.play();
                AudioHelper.WHOOSH.play();
        }
}